export const BASE_API = "https://restcountries.eu/rest/v2";
export const API_ALL_COUNTRIES = `${BASE_API}/all`;
export const API_GET_COUNTRY_BY_NAME = `${BASE_API}/name`;
export const API_GET_COUNTRY_BY_CODE = `${BASE_API}/alpha`;
